export function dataInRequest(params = {}) {
  return {
    type: '@usuarios/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@usuarios/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@usuarios/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@usuarios/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@usuarios/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@usuarios/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@usuarios/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@usuarios/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@usuarios/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@usuarios/RECORD_FILTERING',
    payload: { params },
  };
}
